/** @jsxRuntime classic */
/** @jsx jsx */
// eslint-disable-next-line no-unused-vars
import React from 'react';
import { useTranslation } from 'react-i18next';
import { css, jsx } from '@emotion/react';

import Text from '@mui/material/Typography';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
import BuildOutlinedIcon from '@mui/icons-material/BuildOutlined';

export default function MeetingStatus({ status }) {
  const { t } = useTranslation();
  return (
    <div
      css={css`
        display: flex;
        flex-direction: row;
        flex-wrap: nowrap;
        gap: 6px;
        margin-right: 20px;
        align-items: center;
      `}
    >
      {status === 'error' ? (
        <>
          <Text variant="body2" color="error.main">
            {t('Misslyckades')}
          </Text>
          <ErrorOutlineIcon color="error" />
        </>
      ) : status === 'reviewing' ? (
        <>
          <Text variant="body2" color="info.main">
            {t('Granskas')}
          </Text>
          <BuildOutlinedIcon color="info" />
        </>
      ) : status === 'terminated' ? (
        <>
          <Text variant="body2" color="error.main">
            {t('Avbruten')}
          </Text>
          <ErrorOutlineIcon color="error" />
        </>
      ) : status !== 'ready' && status !== 'ok' ? (
        <>
          <Text variant="body2" color="info.main">
            {t('Behandlas')}
          </Text>
          <BuildOutlinedIcon color="info" />
        </>
      ) : null}
    </div>
  );
}
